var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37587 4.9344H2.34551C2.0335 4.9344 1.78027 5.18763 1.78027 5.49964C1.78027 5.81166 2.0335 6.06488 2.34551 6.06488H8.38906L7.21562 7.23832C6.99518 7.45877 6.99518 7.81713 7.21562 8.03757C7.43644 8.25839 7.79443 8.25839 8.01525 8.03757C8.01525 8.03757 8.98256 7.07026 9.61375 6.43907C10.1289 5.92395 10.1289 5.0889 9.61375 4.57378L8.01525 2.9749C7.79443 2.75446 7.43644 2.75446 7.21562 2.9749C6.99518 3.19572 6.99518 3.55371 7.21562 3.77453L8.37587 4.9344Z",
    fill: "#FF5348"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40606 8.51444V6.81872H2.34612C1.61809 6.81872 1.02723 6.22785 1.02723 5.49982C1.02723 4.77179 1.61809 4.18093 2.34612 4.18093H6.40606V2.48521C6.40606 1.44479 5.56234 0.601074 4.52192 0.601074C3.70572 0.601074 2.70034 0.601074 1.88413 0.601074C1.38446 0.601074 0.905138 0.799662 0.551675 1.15275C0.198588 1.50621 0 1.98554 0 2.48521C0 4.15794 0 6.8417 0 8.51444C0 9.01411 0.198588 9.49343 0.551675 9.8469C0.905138 10.2 1.38446 10.3986 1.88413 10.3986C2.70034 10.3986 3.70572 10.3986 4.52192 10.3986C5.02159 10.3986 5.50092 10.2 5.85438 9.8469C6.20747 9.49343 6.40606 9.01411 6.40606 8.51444Z",
    fill: "#FF5348"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.52bda0ceb4ab252fc9401ef712591861.svg";
export { ForwardRef as ReactComponent };